if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
var lastScrollTop = 0;
(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
    $('.easy-scroll').click(function () { 
        var target = $(this).attr("href");
        if($('body.main').length > 0) { var padding = 0; } else { var padding =$('header').height(); }
        $('html, body').animate({scrollTop: $(target).offset().top - padding}, 1000);
        return false;
    });

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.hero__slider').slick({
        arrows: false, 
        autoplay: true, 
        autoplaySpeed: 5000,
        dots: true, 
        fade: true,
        pauseOnHover: false,
        speed: 700
    });

    $('.specials--slider').slick({
        arrows: true, 
        autoplay: false, 
        autoplaySpeed: 5000,
        dots: false, 
        fade: true,
        pauseOnHover: false,
        speed: 700,
        nextArrow: $('.specials__arrow-prev'),
        prevArrow: $('.specials__arrow-next'),
       
    });

    $('.gallery-content').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    // FANCYBOXES
    $('.fancybox').fancybox({
        arrows: true
    });

    $('.fancybox-module').fancybox({
        maxWidth: 900,
        wrapCSS: 'fancybox-popup__wrapper'
    });

    window.onload = function () {
        scrollW();
        window.addEventListener('scroll', function () {
            scrollW();
        })
    }
    function scrollW() {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > 0) {
            if (st > lastScrollTop) {
                // downscroll code
                if (!document.getElementById('header').classList.contains('down')) {
                    document.getElementById('header').classList.add('down');
                    document.getElementById('header').classList.remove('up');
                }
            } else {
                // upscroll code
                if (!document.getElementById('header').classList.contains('up')) {
                    document.getElementById('header').classList.add('up');
                    document.getElementById('header').classList.remove('down');
                }
            }

        } else {
            if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.remove('up');
                document.getElementById('header').classList.remove('down');
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        if(document.querySelector('body').classList.contains('alert_open')){
            let alertBanner = document.querySelector('#header')
            if(alertBanner){
                let height = alertBanner.style.getPropertyValue("top")
                document.querySelector('body').style.paddingTop = height;
            }
        }
    }
    let ScrollUp = document.getElementsByClassName('js-scrollup');
    if(ScrollUp.length > 0){
        ScrollUp[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    if(document.querySelector('.container_booking-widget')){
        let returnBookingBootonFromGuest = document.querySelector(".back-main-guest");
        let returnBookingBootonFromCalendar = document.querySelector(".back-main-calendar");
        let fromGuest  = document.getElementById("guests-action");
        let fromCalendar  = document.getElementById("date-action__booking");

        let mainOptions = document.querySelector(".main-options");
        let calendarOptions = document.querySelector(".calendar-options");
        let guestOptions = document.querySelector(".guest-options");
        let updateInfoBooking = document.getElementById("update-info__booking");
        let updateCalendarBooking = document.getElementById("update-info__booking-date");
        let InfoBooking = document.querySelector("#guests-action");
        


        let valueCheckIn  = document.getElementById("checkInNewBW");
        let valueCheckOut  = document.getElementById("checkOutNewBW");

        const arrivalDate = document.getElementById("arrivalDate"),
            nightsStay = document.getElementById("nightsStay");
        
        returnBookingBootonFromGuest.addEventListener('click', function() {
            guestOptions.classList.add('hidden');
            mainOptions.classList.remove('hidden');

        })
        returnBookingBootonFromCalendar.addEventListener('click', function() {
            calendarOptions.classList.add('hidden');
            mainOptions.classList.remove('hidden');
            fromCalendar.innerHTML = `${valueCheckIn.value} /  ${valueCheckOut.value}`;
        })

        updateCalendarBooking.addEventListener('click', function() {
            calendarOptions.classList.add('hidden');
            mainOptions.classList.remove('hidden');
            fromCalendar.innerHTML = `${valueCheckIn.value} /  ${valueCheckOut.value}`;

            const start = new Date(valueCheckIn.value),
                year = start.getFullYear(),
                month = String(start.getMonth() + 1).padStart(2, "0"),
                day = String(start.getDate()).padStart(2, "0"),
                end = new Date(valueCheckOut.value);

            arrivalDate.value = `${year}${month}${day}`;

            let nightsLength = end - start;
            nightsLength = nightsLength / (1000 * 60 * 60 * 24);
            nightsStay.value = nightsLength;
        })



        fromGuest.addEventListener('click', function() {
            guestOptions.classList.remove('hidden');
            mainOptions.classList.add('hidden');

        })

        fromCalendar.addEventListener('click', function() {
            calendarOptions.classList.remove('hidden');
            mainOptions.classList.add('hidden');
        })

        updateInfoBooking.addEventListener('click', function() {
            guestOptions.classList.add('hidden');
            mainOptions.classList.remove('hidden');
            InfoBooking.innerHTML = "update info";
        })
    }

})();
function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 1500;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
